// L-99 / H-3 (test liên mạng 07/10/2026): chuỗi và thẻ "Chạy kịch bản" gán BOT chứ không gán theo mạng, nên người dùng chỉ biết bot nào chưa đăng nhập mạng nào hoặc đang TẠM DỪNG mạng nào
// sau khi bấm và bị từ chối (409). Dữ liệu từ GET /api/bots/mang (bot-tong-quan.ts mangCuaBot): mạng bot ĐÃ CHẠY ĐƯỢC + các lần tạm dừng chưa xử lý theo mạng.
// Phần THUẦN (không DOM) + một hàm tải có nhớ ngắn — CHỈ CẢNH BÁO, không chặn ("cảnh báo thay vì chặn").
import { api } from "./api";
import { h } from "./dom";

export interface TamDungMang { mang: string; ma: string; lyDo: string; luc: string }
export interface BotMangView { mangDaChay: string[]; tamDung: TamDungMang[] }
export type BotMangMap = Record<string, BotMangView>;
export type TenMang = (ma: string | null) => string;

const CHU_MA: Record<string, string> = {
  captcha: "CAPTCHA", checkpoint: "tài khoản cần xác nhận", xac_minh: "cần xác minh", dang_xuat: "bị đăng xuất", spam: "bị cảnh báo spam", can_nguoi: "cần bạn xử lý",
};
const chuMa = (ma: string): string => CHU_MA[ma] ?? "cần xử lý";

/** “Tạm dừng: CAPTCHA (TikTok)” — chip đỏ của một lần tạm dừng theo mạng. */
export const chuTamDungMang = (td: TamDungMang, tenMang: TenMang): string => `Tạm dừng: ${chuMa(td.ma)} (${tenMang(td.mang)})`;

/** “Đã chạy được: Facebook, YouTube” / “Chưa chạy được mạng nào” / "" (chưa có dữ liệu — không bịa). */
export function chuMangDaChay(mang: string[] | undefined, tenMang: TenMang): string {
  if (!mang) return "";
  return mang.length ? `Đã chạy được: ${mang.map((m) => tenMang(m)).join(", ")}` : "Chưa chạy được mạng nào";
}

export type LoaiCanhBaoBot = "tam-dung" | "chua-chay";
export interface CanhBaoBot { botId?: string; loai: LoaiCanhBaoBot; chu: string }

/** Cảnh báo của MỘT bot với mạng của một kịch bản: đang tạm dừng mạng đó (bị từ chối khi chạy) / chưa từng chạy được mạng đó (chưa chắc đã đăng nhập). null = ổn hoặc không đủ dữ liệu. */
export function canhBaoBotMang(tenBot: string, bm: BotMangView | undefined, nenTang: string | null, tenMang: TenMang): CanhBaoBot | null {
  if (!bm || !nenTang) return null;
  const td = bm.tamDung.find((t) => t.mang === nenTang);
  if (td) return { loai: "tam-dung", chu: `Bot “${tenBot}” đang TẠM DỪNG ${tenMang(nenTang)}: ${chuMa(td.ma)} — kịch bản này sẽ bị bot từ chối tới khi bạn xử lý và bấm “Cho chạy lại” ở trang Chờ duyệt` };
  if (!bm.mangDaChay.includes(nenTang)) return { loai: "chua-chay", chu: `Bot “${tenBot}” chưa từng chạy được ${tenMang(nenTang)} — chưa chắc đã đăng nhập ${tenMang(nenTang)} trên trình duyệt của bot (vẫn chạy được, nhưng có thể lỗi ngay bước đầu)` };
  return null;
}

/** Cảnh báo cho TỪNG bước của chuỗi (cùng thứ tự `buoc`): mỗi bot được tick × mạng của kịch bản ở bước đó. Bước đã xoá / không có mạng → []. */
export function canhBaoChuoiTheoBuoc(buoc: { kichBanId: string; nenTang: string | null; daXoa: boolean }[], botIds: string[], tenBot: (id: string) => string, botMang: BotMangMap, tenMang: TenMang): CanhBaoBot[][] {
  return buoc.map((b) => {
    if (b.daXoa || !b.nenTang) return [];
    const ds: CanhBaoBot[] = [];
    for (const id of botIds) {
      const c = canhBaoBotMang(tenBot(id), botMang[id], b.nenTang, tenMang);
      if (c) ds.push({ ...c, botId: id });
    }
    return ds;
  });
}

let nho: { luc: number; ds: Promise<BotMangMap> } | null = null;
/** Tải dữ liệu mạng của các bot (nhớ 5 giây — trang chuỗi / thẻ chạy kịch bản hỏi liên tiếp). Lỗi mạng → {} (trang vẫn chạy, chỉ không có chip). */
export function taiBotMang(manh = false): Promise<BotMangMap> {
  if (!manh && nho && Date.now() - nho.luc < 5000) return nho.ds;
  const ds = api<{ bots: BotMangMap }>("GET", "/api/bots/mang").then((r) => r.bots ?? {}).catch(() => ({} as BotMangMap));
  nho = { luc: Date.now(), ds };
  return ds;
}
export function quenBotMang(): void { nho = null; }

const TEN_MANG_CO_DINH: Record<string, string> = { facebook: "Facebook", youtube: "YouTube", tiktok: "TikTok", x: "X (Twitter)", reddit: "Reddit" };
/** Tên mạng hiển thị khi trang không có sẵn bản đồ thao tác (thẻ Chạy kịch bản): 5 mạng đã biết, còn lại giữ nguyên mã; null → "AI chọn". */
export const tenMangCoDinh: TenMang = (ma) => (ma ? TEN_MANG_CO_DINH[ma] ?? ma : "AI chọn");

/** Các chip của một bot: “Đã chạy được: …” + chip đỏ cho từng mạng đang tạm dừng. Dựng bằng textContent (tên mạng lạ hiện đúng chữ). */
export function chipBotMang(bm: BotMangView | undefined, tenMang: TenMang): HTMLElement[] {
  if (!bm) return [];
  const out: HTMLElement[] = [];
  const chu = chuMangDaChay(bm.mangDaChay, tenMang);
  if (chu) out.push(h("span", { class: `tag ${bm.mangDaChay.length ? "ok" : ""}`, "data-testid": "bot-mang-da-chay", title: "Mạng mà bot này đã có ít nhất một lần chạy xong (nghĩa là đã đăng nhập mạng đó trên trình duyệt của bot)" }, chu));
  for (const t of bm.tamDung) out.push(h("span", { class: "tag err", "data-testid": "bot-mang-tam-dung", dataset: { mang: t.mang }, title: `${t.lyDo} — bot này không nhận việc của mạng đó tới khi bạn xử lý và bấm “Cho chạy lại”` }, chuTamDungMang(t, tenMang)));
  return out;
}
